import CompraCombobox from "./CompraCombobox.vue";

export {CompraCombobox}
export default CompraCombobox


